import React from 'react';

const About = () => {
    return (
        <div>
            <div className="card">
                <div className="card-content">
                    <h6 className="mt-bottom">
                        <strong>ABOUT ME</strong>
                    </h6>
                    <p className="grey-text">
                        <strong>
                            My full name's Nguyễn Hồng Thắng. I live in Việt
                            Nam. I want to develop myself to be a better person.
                            Thank for visting!
                        </strong>
                    </p>
                </div>
                <div className="card-action">
                    <h6>
                        <strong>PERSONAL INFO</strong>
                    </h6>
                    <div className="row mt">
                        <div className="col xl6 l6 m6 s12">
                            <p>
                                <strong>Address:</strong> Diễn Châu, Nghê An
                            </p>
                            <p>
                                <strong>Email:</strong> thangngh.00@gmail.com
                            </p>
                            <p>
                                <strong>MSV:</strong> 18574802016001
                            </p>
                            <p>
                                <strong>Phone:</strong> 0383464010
                            </p>
                        </div>
                        <div className="col xl6 l6 m6 s12">
                            <p>
                                <strong>Main Language</strong> - VietNamese
                            </p>
                            <p>
                                <strong>Second Language</strong> - English
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
